<template>
  <div :class="{ section_3: arg == '' }">
    <div v-if="arg == ''" class="f0" style="padding-top: 1rem">
      <div class="block_1"></div>
      <span class="paragraph_1">
        恭喜您升级成功，请下载APP，
        <br />
        使用注册手机号登录，享受对应权益
      </span>
      <van-button
        class="text-wrapper_2"
        type="primary"
        round
        color="linear-gradient( 90deg, #FC0324 0%, #F63A66 100%)"
        @click="download"
      >
        下载APP
      </van-button>
    </div>
    <div v-else class="f0">
      <div class="section_3 section_3_xcx" style="padding: 0.41rem 0">
        <div class="block_1"></div>
        <span class="paragraph_1">
          恭喜您升级成功，请下载APP，
          <br />
          使用注册手机号登录，享受对应权益
        </span>
      </div>
      <img class="download" src="/static/images/VIP/app_download.png" alt="" />
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import { isWeixin, fenxiang, downloadpath } from '../../assets/common/js/config'
// import wx from "weixin-js-sdk";

export default {
  name: 'vipupSuccess',
  data() {
    return {
      arg: this.$app.arg
    }
  },
  mounted() {
    console.log(this.$app.arg)
    if (isWeixin()) {
      fenxiang({ path: 'vipupSuccess' })
    }
  },
  methods: {
    getData() {},
    download() {
      window.location = downloadpath
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/footerSubmit';
.section_3 {
  box-shadow: 0 0.02rem 0.19rem 0 rgba(226, 228, 234, 0.75);
  background-color: rgba(255, 255, 255, 1);
  margin-top: 0.01rem;
}
.section_3_xcx {
  box-shadow: 0 0.02rem 0.19rem 0 rgba(226, 228, 234, 0.75);
  border-radius: 0 0 0.1rem 0.1rem;
}
.block_1 {
  width: 0.6rem;
  height: 0.6rem;
  background: url('/static/images/VIP/success.png') 100% no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
}

.paragraph_1 {
  display: block;
  overflow-wrap: break-word;
  color: rgba(34, 34, 34, 1);
  font-size: 0.16rem;
  font-weight: 500;
  text-align: center;
  line-height: 0.22rem;
  margin-top: 0.24rem;
}

.text-wrapper_2 {
  display: block;
  height: 0.43rem;
  line-height: 0.43rem;
  background: linear-gradient(90deg, #fc0324 0%, #f63a66 100%);
  border-radius: 0.25rem;
  width: 2.55rem;
  margin: 0.4rem auto 0;
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;
}
.download {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/upgradeVIP/vipupSuccess.vue